module.exports = __webpack_public_path__ + "img/hinzufuegen-box.449cef58.svg";